import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Service to handle module dropdown shortcut requests (Alt+M, Alt+T, etc.)
 * Components subscribe to openDropdown$ and open/expand the matching module dropdown.
 */
@Injectable({ providedIn: 'root' })
export class ModuleDropdownShortcutService {
  private readonly _openDropdown$ = new Subject<string>();

  /** Emits module IDs (masters, transactions, reports, administration, utilities) when shortcut is pressed */
  readonly openDropdown$ = this._openDropdown$.asObservable();

  /**
   * Request opening the dropdown for the given module
   * @param moduleId - One of: masters, transactions, reports, administration, utilities
   */
  requestOpenDropdown(moduleId: string): void {
    this._openDropdown$.next(moduleId);
  }
}
